import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-agile-embrace',
  templateUrl: './agile-embrace.component.html',
  styleUrls: ['./agile-embrace.component.sass']
})
export class AgileEmbraceComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    document.querySelector(".__page-root").scrollIntoView(true);
  }

}
